import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Form from '@/components/form/Form'
import Generated from '@/components/Generated'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/form',
      name: 'Form',
      component: Form
    },
    {
      path: '/generated',
      name: 'Generated',
      component: Generated
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js